import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-gauge-charts",
  templateUrl: "./gauge-charts.component.html",
  styleUrls: ["./gauge-charts.component.scss"]
})
export class GaugeChartsComponent implements OnInit {
  public dataSource: any;
  public chart: any;

  @Input() chartData = { type: "AngularGauge" };
  constructor() {
    this.dataSource = {
      chart: {
        caption: "",
        lowerLimit: "0",
        upperLimit: "1",
        valueFontSize: "11",
        valueFontBold: "0",
        showValue: "1",
        numberSuffix: "",
        decimals: "2",
        theme: "fusion",
        showToolTip: "1",
        legendPosition: "bottom",
        chartLeftMargin: "1",
        chartTopMargin: "1",
        chartRightMargin: "1",
        chartBottomMargin: "1",
        captionPadding: "5",
        canvasPadding: "0",
        manageResize: 1
      },
      // Chart Data
      colorRange: {
        color: [
          {
            minValue: "0",
            maxValue: "0.2",
            code: "#F0534F",
            label: "Poor"
          },
          {
            minValue: "0.2",
            maxValue: "0.4",
            code: "#F2726F",
            label: "Week"
          },
          {
            minValue: "0.4",
            maxValue: "0.60",
            code: "#FFC533",
            label: "Moderate"
          },
          {
            minValue: "0.6",
            maxValue: "0.80",
            code: "#62B58F",
            label: "Good"
          },
          {
            minValue: "0.8",
            maxValue: "1",
            code: "#30B679",
            label: "Excellent"
          }
        ]
      },
      dials: {
        dial: []
      }
    };
  }

  ngOnInit() {}

  initialized($event) {
    this.chart = $event.chart; // Storing the chart instance
    this.updateGaugeValue(this.chartData);
  }

  /* updateGaugeValue(data) {
    if (this.chart) {
      this.dataSource["chart"]["caption"] = data.caption;
      this.dataSource["chart"]["lowerLimitDisplay"] = data.lowerLimitDisplay;
      this.dataSource["chart"]["upperLimitDisplay"] = data.upperLimitDisplay;
      this.dataSource["dials"]["dial"].push({ value: data.value });
      // this.chart.setChartAttribute({ caption: data.caption });
      // this.chart.feedData('&value=' + data.value);
      console.log("####### colorRange", data.colorRange);
      if (data.chart !== undefined) {
        this.dataSource["chart"] = data.chart;
      }
      if (data.dials !== undefined) {
        this.dataSource["dials"] = data.dials;
      }
      if (data.colorRange !== undefined) {
        this.dataSource["colorRange"] = data.colorRange;
      }
      if (data.annotations !== undefined) {
        this.dataSource["annotations"] = data.annotations;
      }
      this.chart.setJSONData(this.dataSource);
      console.log("####### dataSource #######", data, this.dataSource);
    }
  } */
  updateGaugeValue(data) {
    if (this.chart) {
      // ✅ Update chart attributes
      this.dataSource["chart"]["caption"] = data.caption;
      this.dataSource["chart"]["lowerLimitDisplay"] = data.lowerLimitDisplay;
      this.dataSource["chart"]["upperLimitDisplay"] = data.upperLimitDisplay;
      this.dataSource["dials"]["dial"].push({ value: data.value });

      if (data.chart !== undefined) {
        this.dataSource["chart"] = data.chart;
      }
      if (data.dials !== undefined) {
        this.dataSource["dials"] = data.dials;
      }
      if (data.colorRange !== undefined) {
        this.dataSource["colorRange"] = data.colorRange;
      }
      if (data.annotations !== undefined) {
        this.dataSource["annotations"] = data.annotations;
      }
      //this.chart.setJSONData(this.dataSource);

      // ✅ Fix: update dial value, not push
      this.dataSource.dials.dial[0].value = String(data.value);

      // ✅ Toggle center label visibility based on value
      this.updateCenterLabel(data.value);

      this.chart.setJSONData(this.dataSource);

      //console.log("####### dataSource #######", data, this.dataSource);
    }
  }

  updateCenterLabel(value) {
    const index = this.getSegmentIndex(value);
    const groups =
      this.dataSource &&
      this.dataSource.annotations &&
      this.dataSource.annotations.groups;

    if (!groups) return;

    // ✅ Find center-value-group by id
    const centerGroup = groups.find(function(g) {
      return g.id === "center-value-group";
    });

    if (!centerGroup) return;

    centerGroup.items.forEach(function(item, i) {
      item.alpha = i === index ? "100" : "0";
    });
  }

  getSegmentIndex(value) {
    if (value <= 16.67) return 0; // Low
    if (value <= 33.33) return 1; // Low to Moderate
    if (value <= 50) return 2; // Moderate
    if (value <= 66.67) return 3; // Moderately High
    if (value <= 83.33) return 4; // High
    return 5; // Very High
  }
}
